/*
 * @Author: wuzuojie 15727841808@163.com
 * @Date: 2023-07-31 20:06:21
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-25 10:42:20
 * @FilePath: /chaoyongtuan/src/utils/dict.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 *
 * 数据字典工具类
 */
import store from '@/store';

export const DICT_TYPE = {
	USER_TYPE: 'user_type',
	COMMON_STATUS: 'common_status',

	// ========== SYSTEM 模块 ==========
	SYSTEM_SCOPE_TYPE: 'system_scope_type',
	SYSTEM_ROLE_TYPE_CPS: 'system_role_type_cps',
	SYSTEM_DATA_SCOPE: 'system_data_scope',
	SYSTEM_VERSION_CLASS: 'system_version_class',
	SELLER_ORDER_STATUS_TYPE: 'seller_order_status_type',
	YX_PROMOTER: 'yx_promoter',
	YX_PROMOTER_DY: 'yx_promoter_dy',
	YX_PROMOTER_SP: 'yx_promoter_sp',
	SELLER_MEDIA_TYPE: 'seller_media_type',
	SELLER_YX_BELONG_TYPE: 'seller_yx_belong_type',
	SYSTEM_TASK_CENTER_STATUS: 'system_task_center_status',
	SYSTEM_TASK_CENTER_TASK_TYPE: 'system_task_center_task_type',
	ANCHOR_MEDIA_TYPE: 'anchor_media_type',
	ONLY_TALENT_PERMISSION: 'only_talent_permission',
	LOGIN_BACKGROUND_TMPL: 'login_background_tmpl',
};

/**
 * 获取 dictType 对应的数据字典数组
 *
 * @param dictType 数据类型
 * @returns {*|Array} 数据字典数组
 */
export function getDictDatas(dictType) {
	return store.getters?.dict_datas?.[dictType] || [];
}

/**
 * 获取 dictType 对应的数据字典数组
 *
 * @param dictType 数据类型
 * @param values 数组、单个元素
 * @returns {*|Array} 数据字典数组
 */
export function getDictDatas2(dictType, values) {
	if (values === undefined) {
		return [];
	}
	// 如果是单个元素，则转换成数组
	if (!Array.isArray(values)) {
		// 传this，增加了方法和组件的耦合,直接values解耦
		values = [values];
	}
	// 获得字典数据
	const results = [];
	for (const value of values) {
		const dict = getDictData(dictType, value);
		if (dict) {
			results.push(dict);
		}
	}
	return results;
}

export function getDictData(dictType, value) {
	// 获取 dictType 对应的数据字典数组
	const dictDatas = getDictDatas(dictType);
	if (!dictDatas || dictDatas.length === 0) {
		return '';
	}
	// 获取 value 对应的展示名
	value = value + ''; // 强制转换成字符串，因为 DictData 小类数值，是字符串
	for (const dictData of dictDatas) {
		if (dictData.value === value) {
			return dictData;
		}
	}
	return undefined;
}

export function getDictData2(dictType, label) {
	// 获取 dictType 对应的数据字典数组
	const dictDatas = getDictDatas(dictType);
	if (!dictDatas || dictDatas.length === 0) {
		return '';
	}
	// 获取 label 对应的value值
	for (const dictData of dictDatas) {
		if (dictData.label === label) {
			return dictData;
		}
	}
	return undefined;
}

export function getDictDataLabel2(dictType, label) {
	const dict = getDictData2(dictType, label);
	return dict ? dict.value : '';
}

export class getDictDataL {}
